import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Icon = styled.img``;

export const PanelsGroupWrapper = styled.div`
  margin-bottom: 24px;
  width: 280px;

  @media (min-width: ${DEVICE.mobileM}) {
    width: 325px;
  }

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
  }
`;

export const PanelsGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${DEVICE.laptop}) {
    display: grid;
    gap: 16px;
    width: 100%;
    grid-template-columns: 1fr;
  }

  @media (min-width: ${DEVICE.laptopM}) {
    display: grid;
    gap: 16px;
    width: 856px;
    grid-template-columns: 1fr 1fr;
  }
`;
